






















import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {dataService} from "../../services/data/data-service";
import {translate} from "../../services/translation/translation";
import {ProjectEvent} from "../../model/project";

declare let isJury;
declare let showPubliWinner;

@Component
export default class BadgesComponent extends Vue {
    @Prop() projectId!: number;
    @Prop() badgesData!: {
        nominee: string;
        winner: string;
        total_winner: string;
    };
    ranking: string | null = null;
    subscription = null;
    isJuryMember = isJury;
    isShowPubliWinner = false;

    getPlace() {
        this.ranking = dataService.getVote(this.projectId);
        return dataService.best10Place(this.projectId) + 1;
    }

    mounted() {
        this.ranking = dataService.getVote(this.projectId);
        this.isShowPubliWinner = typeof showPubliWinner != 'undefined' ? showPubliWinner : 0;
    }

    getPlaceText() {
        return this.getPlace() + ".";
    }

    trans(key) {
        return translate(key);
    }
}
